import {
  RECEIVE_SERVER_RESPONSE,
  RECEIVE_WARROOMSERVER_RESPONSE,
  PAGE_SELECTED,
  LOAD_USERDATA,
  BRAND_SELECTED,
  BRANCH_SELECTED,
  LOGOUT,
  ALERT,
  CLEAR_NAV_HISTORY,
  STEP_BACK,
  UPDATE_GLOBAL_SEARCH,
  RECEIVE_CODEXLBSERVER_RESPONSE,
  LOAD_ACCOUNTS,
  RELOAD_BRANDS,
  SET_ACTIVE_ACCOUNT_ID,
  LOAD_PLAN_DATA,
  LOAD_PLAN_OVERRIDES,
} from "../actions/actionTypes";

import axios from "axios";
import {
  SERVER_CONFIG,
  CODEXLB_SERVER_URI,
  WARROOM_SERVER_URI,
} from "../Config";
import { LITE_SERVER_CONFIG } from "../pages/lite/config/Config_lite";
import Constants from "../data/constants";
import StringHelper from "../helpers/StringHelper";
import { Modal } from "antd";
import DataHelper from "../helpers/DataHelper";
import Messages from "../data/messages";

//Action Creator
export const selectPage = (pageID, content = null, doAddToHistory = true) => {
  // console.log("selectPage" + pageID)

  console.log("action selectPAge " + pageID);
  return {
    type: PAGE_SELECTED,
    payload: {
      id: String(pageID),
      content: content,
      doAddToHistory: doAddToHistory,
    },
  };
};

export const selectBrand = (brandData = null) => {
  // console.log("SELECT BRAND " + brandData)
  return {
    type: BRAND_SELECTED,
    payload: brandData,
  };
};

export const selectBranch = (branchData = null) => {
  return {
    type: BRANCH_SELECTED,
    payload: branchData,
  };
};

export const updateGlobalSearch = (searchWord) => {
  return {
    type: UPDATE_GLOBAL_SEARCH,
    payload: searchWord,
  };
};

export const clearNavHistory = () => {
  return {
    type: CLEAR_NAV_HISTORY,
    payload: null,
  };
};

export const stepBack = () => {
  return {
    type: STEP_BACK,
    payload: null,
  };
};

export const requestServerGet = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
) => {
  // console.log("requestServerGet action: " + action + " params: " + JSON.stringify(params) + " headers: " + JSON.stringify(headers) + " userToken: " + userToken);
  const systemheaders = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${userToken}`,
  };
  headers = { ...systemheaders, ...headers };

  const brandBranch = StringHelper.extractURLBrandAndBranch(
    window.location.pathname,
  );

  // console.log(
  //   "requestServerGet brandBranch " +
  //     action +
  //     " " +
  //     JSON.stringify(brandBranch),
  // );

  const BRAND_ONLY_ACTIONS = ["get_branches"];

  if (!hasValidKey(params, "brandid") && brandBranch.brandid) {
    console.log("no brandid");
    setKey(params, "brandid", brandBranch.brandid);
  }

  if (!BRAND_ONLY_ACTIONS.includes(action)) {
    if (!hasValidKey(params, "branchid") && brandBranch.branchid) {
      console.log("no branchid");
      params.branchid = brandBranch.branchid;
      setKey(params, "branchid", brandBranch.branchid);
    }
  }

  return (dispatch) => {
    axios
      .get(`${SERVER_CONFIG.SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`, {
        params: params,
        headers: headers,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_SERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });
            handleResponse(response, callback, dispatch);
          }
        },
        (error) => {
          console.log("get request error: " + error);
          dispatch(logout());
        },
      );
  };
};

function parseResponseData(data) {
  if (data === null || data === undefined) return data;
  if (typeof data !== "string") return data;
  // Strip PHP warnings / HTML noise after the first JSON structure
  const firstBrace = data.indexOf("{");
  const firstBracket = data.indexOf("[");
  let start = -1;
  if (firstBrace !== -1 && (firstBracket === -1 || firstBrace < firstBracket)) {
    start = firstBrace;
  } else if (firstBracket !== -1) {
    start = firstBracket;
  }
  if (start === -1) return data;
  try {
    // Find matching end by attempting incremental parse
    const candidate = data.slice(start);
    // Remove anything after the last valid closing brace/bracket
    const lastBrace = candidate.lastIndexOf("}");
    const lastBracket = candidate.lastIndexOf("]");
    const end = Math.max(lastBrace, lastBracket);
    if (end === -1) return data;
    return JSON.parse(candidate.slice(0, end + 1));
  } catch (e) {
    return data;
  }
}

const handleResponse = (
  response,
  callback,
  dispatch,
  failCallback = () => {},
) => {
  // console.log("handleResponse res", response);
  // Normalize data: parse if server returned text/html with embedded JSON
  if (typeof response.data === "string") {
    response = { ...response, data: parseResponseData(response.data) };
  }
  if (
    response.data &&
    typeof response.data === "object" &&
    "status" in response.data
  ) {
    if (!(response.data.status === "error")) {
      if (callback) {
        callback(response);
      }
    } else {
      if (response.data.code === 600) {
        if (!DataHelper.logoutInProgress) {
          DataHelper.logoutInProgress = true;
          console.log("LOGOUT");
          let message = response.data.message || Messages.SESSION_OVER_MESSAGE;
          if (DataHelper.nextSessionOverMessage) {
            message = DataHelper.nextSessionOverMessage;
            DataHelper.nextSessionOverMessage = null;
          }
          Modal.info({
            title: "Session Expired",
            content: message,
            onOk: () => {
              dispatch(logout()); // reset when back to login page
            },
          });
        }
      } else {
        dispatch(alert(response.data.message ?? "Something wen wrong"));
      }
      failCallback(response);
    }
  } else {
    if (callback) {
      callback(response);
    }
  }
};

export const logout = () => {
  console.log("logout");
  // Preserve UI preferences that should survive sign-out
  const UI_PREFS = [
    "brand-view-mode",
    "media-view-mode",
    "pro-tour-completed",
    "lite-tour-completed",
  ];
  const saved = {};
  UI_PREFS.forEach((k) => {
    const v = localStorage.getItem(k);
    if (v !== null) saved[k] = v;
  });
  localStorage.clear();
  Object.entries(saved).forEach(([k, v]) => localStorage.setItem(k, v));
  selectPage(Constants.LOGIN_PAGE, null, false);
  return {
    type: LOGOUT,
    payload: {},
  };
};

export const alert = (message) => {
  return {
    type: ALERT,
    payload: message,
  };
};

export const loadAccounts = (accounts) => {
  return {
    type: LOAD_ACCOUNTS,
    payload: accounts,
  };
};

export const reloadBrands = () => {
  return {
    type: RELOAD_BRANDS,
    payload: null,
  };
};

export const setActiveAccountId = (accountId) => ({
  type: SET_ACTIVE_ACCOUNT_ID,
  payload: accountId != null ? String(accountId) : null,
});

/**
 * Store the user's subscription plan data (from get_subscriptionplans API).
 * @param {Object|null} planData — the plan object for the current user
 */
export const loadPlanData = (planData) => ({
  type: LOAD_PLAN_DATA,
  payload: planData,
});

/**
 * Store per-user plan overrides (set by sales for custom deals).
 * @param {Object|null} overrides — key/value overrides that take precedence over the plan
 */
export const loadPlanOverrides = (overrides) => ({
  type: LOAD_PLAN_OVERRIDES,
  payload: overrides,
});

export const loadUserData = (userdata) => {
  try {
    return {
      type: LOAD_USERDATA,
      payload: userdata,
    };
  } catch (e) {
    console.log("invalid user data");
    return logout();
  }
};

function hasValidKey(data, key) {
  if (data instanceof FormData) {
    return data.has(key); // Use the dynamic key, not the string "key"
  } else if (typeof data === "object" && data !== null) {
    return key in data && data[key] !== undefined; // Use dynamic key lookup
  }
  return false;
}
function setKey(data, key, value) {
  if (data instanceof FormData) {
    if (!data.has(key)) data.append(key, value); // Append only if not already set
  } else if (typeof data === "object" && data !== null) {
    if (!(key in data) || data[key] === undefined) data[key] = value; // Assign if missing or undefined
  }
}

function normalizeParams(params) {
  if (!(params instanceof FormData)) return params;

  let containsFile = false;
  const json = {};

  params.forEach((value, key) => {
    if (value instanceof File || value instanceof Blob) {
      containsFile = true;
      return;
    }

    // Try to restore original type
    // json[key] = restoreType(value);

    const restoredValue = restoreType(value);

    // Handle array keys: roleids[]
    if (key.endsWith("[]")) {
      const cleanKey = key.slice(0, -2);

      if (!Array.isArray(json[cleanKey])) {
        json[cleanKey] = [];
      }

      json[cleanKey].push(restoredValue);
    } else {
      json[key] = restoredValue;
    }
  });

  return containsFile ? params : json;
}

function restoreType(value) {
  if (value === "null") return null;
  if (value === "undefined") return undefined;

  // boolean
  if (value === "true") return true;
  if (value === "false") return false;

  // number (only if valid number)
  if (!isNaN(value) && value.trim() !== "") {
    return Number(value);
  }

  // fallback to original string
  return value;
}

export const requestServerPost = (
  action,
  rawParams = {},
  headers = {},
  callback = null,
  userToken = "",
  config = {},
  failCallback = () => {},
) => {
  const systemheaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${userToken}`,
  };
  // const systemheaders = {}
  headers = { ...systemheaders, ...headers };

  const params = normalizeParams(rawParams);

  console.log(
    "requestServerPost brandBranch " + action + " " + JSON.stringify(params),
  );
  const brandBranch = StringHelper.extractURLBrandAndBranch(
    window.location.pathname,
  );

  if (!hasValidKey(params, "brandid") && brandBranch.brandid) {
    console.log("no brandid");
    setKey(params, "brandid", brandBranch.brandid);
  }

  if (!hasValidKey(params, "branchid") && brandBranch.branchid) {
    console.log("no branchid");
    params.branchid = brandBranch.branchid;
    setKey(params, "branchid", brandBranch.branchid);
  }

  console.log(
    "requestServerPost brandBranch " + action + " " + JSON.stringify(params),
  );
  console.log("headers " + JSON.stringify(headers));
  return (dispatch) => {
    // console.log("dispatch " + dispatch)
    axios
      .post(
        `${SERVER_CONFIG.SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`,
        params,
        {
          headers: headers,
          ...config,
        },
      )
      .then(
        (response) => {
          // console.log("response " + JSON.stringify(response))
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_SERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });

            handleResponse(response, callback, dispatch, failCallback);
          }
        },
        (reason) => {
          console.log(reason);
          failCallback(reason);
        },
      );
  };
};

/**
 * Social login via Firebase ID token (Google / Facebook).
 * Sends { idToken, email, displayName, photoURL, uid, social_channel, provider }
 * to the server using the same pattern as requestServerPost, and dispatches
 * RECEIVE_SERVER_RESPONSE on success.
 *
 * @param {string} action        – API endpoint, e.g. "social_login"
 * @param {object} socialPayload – { idToken, email, displayName, photoURL, uid, social_channel }
 * @param {string} provider      – "google" | "facebook"
 * @param {function} callback    – called with response on success
 * @param {string} userToken     – optional bearer token
 * @param {function} failCallback – called with reason/response on failure
 */
export const requestServerPostSocialLogin = (
  action,
  socialPayload = {},
  provider = "",
  callback = null,
  userToken = "",
  failCallback = () => {},
) => {
  const systemheaders = {
    "Content-Type": "application/json",
    ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
  };

  const params = {
    idToken: socialPayload.idToken,
    email: socialPayload.email,
    displayName: socialPayload.displayName,
    photoURL: socialPayload.photoURL,
    uid: socialPayload.uid,
    social_channel: socialPayload.social_channel || provider,
    provider,
  };

  const brandBranch = StringHelper.extractURLBrandAndBranch(
    window.location.pathname,
  );

  if (!hasValidKey(params, "brandid") && brandBranch.brandid) {
    // console.log("no brandid");
    setKey(params, "brandid", brandBranch.brandid);
  }

  if (!hasValidKey(params, "branchid") && brandBranch.branchid) {
    // console.log("no branchid");
    params.branchid = brandBranch.branchid;
    setKey(params, "branchid", brandBranch.branchid);
  }

  return (dispatch) => {
    axios
      .post(
        `${SERVER_CONFIG.SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`,
        params,
        { headers: systemheaders },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_SERVER_RESPONSE,
              payload: { action, response },
            });
            handleResponse(response, callback, dispatch, failCallback);
          }
        },
        (reason) => {
          console.log(reason);
          failCallback(reason);
        },
      );
  };
};

export const requestLiteRegister = (
  action,
  payload = {},
  callback = null,
  userToken = "",
  failCallback = () => {},
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${userToken}`,
  };
  const params = {
    email: payload.email,
    password: payload.password,
    first_name: (payload.firstName || "").trim(),
    last_name: (payload.lastName || "").trim(),
    username: (payload.username || "").trim(),
    company: (payload.company || "").trim(),
  };

  return (dispatch) => {
    axios
      .post(
        `${SERVER_CONFIG.SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`,
        params,
        {
          headers,
          timeout: 15000,
        },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_SERVER_RESPONSE,
              payload: { action, response },
            });
            handleResponse(response, callback, dispatch, failCallback);
          }
        },
        (reason) => {
          console.log("[requestLiteRegister] error:", reason);
          failCallback(reason);
        },
      );
  };
};

export const requestNodeServerPost = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
) => {
  const systemheaders = { "Content-Type": "application/x-www-form-urlencoded" };
  // const systemheaders = {}
  headers = { ...headers, ...systemheaders };

  const brandBranch = JSON.stringify(
    StringHelper.extractURLBrandAndBranch(window.location.pathname),
  );

  console.log(
    "requestNodeServerPost : brandBranch " + action + " " + brandBranch,
  );
  return (dispatch) => {
    console.log("dispatch " + dispatch);
    axios
      .post(`${SERVER_CONFIG.NODE_SERVER_URI}api/v1/${action}`, params, {
        headers: headers,
      })
      .then(
        (response) => {
          // console.log("response " + JSON.stringify(response))
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_SERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });
            if (callback) {
              callback(response);
            }
          }
        },
        (reason) => {
          console.log(reason);
        },
      );
  };
};

export const requestFilesServerPost = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
  config = {},
) => {
  const systemheaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${userToken}`,
  };
  // const systemheaders = {}
  headers = { ...headers, ...systemheaders };

  console.log(
    "requestFilesServerPost brandBranch " +
      action +
      " " +
      JSON.stringify(params),
  );
  const brandBranch = StringHelper.extractURLBrandAndBranch(
    window.location.pathname,
  );

  if (!hasValidKey(params, "brandid") && brandBranch.brandid) {
    console.log("no brandid");
    setKey(params, "brandid", brandBranch.brandid);
  }

  if (!hasValidKey(params, "branchid") && brandBranch.branchid) {
    console.log("no branchid");
    params.branchid = brandBranch.branchid;
    setKey(params, "branchid", brandBranch.branchid);
  }

  console.log(
    "requestFilesServerPost brandBranch " +
      action +
      " " +
      JSON.stringify(params),
  );
  return (dispatch) => {
    // console.log("dispatch " + dispatch)
    axios
      .post(
        `${SERVER_CONFIG.FILES_SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`,
        params,
        {
          headers: headers,
          ...config,
        },
      )
      .then(
        (response) => {
          // console.log("response " + JSON.stringify(response))
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_SERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });

            handleResponse(response, callback, dispatch);
          }
        },
        (reason) => {
          console.log(reason);
        },
      );
  };
};

export const requestWarroomServerPost = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
) => {
  const systemheaders = { "Content-Type": "application/x-www-form-urlencoded" };
  // const systemheaders = {}
  headers = { ...headers, ...systemheaders };

  const brandBranch = JSON.stringify(
    StringHelper.extractURLBrandAndBranch(window.location.pathname),
  );

  console.log(
    "requestWarroomServerPost : brandBranch " + action + " " + brandBranch,
  );
  return (dispatch) => {
    console.log("dispatch " + dispatch);
    axios
      .post(`${WARROOM_SERVER_URI}api/${action}`, params, {
        headers: headers,
      })
      .then(
        (response) => {
          // console.log("response " + JSON.stringify(response))
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_WARROOMSERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });
            if (callback) {
              callback(response);
            }
          }
        },
        (reason) => {
          console.log(reason);
        },
      );
  };
};

export const requestWarroomServerGet = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
) => {
  const systemheaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${userToken}`,
  };
  headers = { ...headers, ...systemheaders };

  const brandBranch = JSON.stringify(
    StringHelper.extractURLBrandAndBranch(window.location.pathname),
  );

  console.log(
    "requestWarroomServerGet : brandBranch " + action + " " + brandBranch,
  );
  return (dispatch) => {
    console.log("dispatch " + dispatch);
    axios
      .get(`${WARROOM_SERVER_URI}api/${action}`, {
        params: params,
        headers: headers,
      })
      .then(
        (response) => {
          console.log("response " + JSON.stringify(response));
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_WARROOMSERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });
            if (callback) {
              callback(response);
            }
          }
        },
        (reason) => {
          console.log(reason);
        },
      );
  };
};

export const requestCodexLBServerPost = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
) => {
  const systemheaders = { "Content-Type": "application/json" };
  // const systemheaders = {}
  headers = { ...headers, ...systemheaders };

  const paramsString = JSON.stringify(params);
  const timestamp = Date.now().toString();
  const encryptedParams = StringHelper.encryptWithTimeStamp(
    paramsString,
    timestamp,
  );

  const newParams = {
    data: encryptedParams,
    timestamp: timestamp,
  };

  const brandBranch = JSON.stringify(
    StringHelper.extractURLBrandAndBranch(window.location.pathname),
  );

  //`${SERVER_CONFIG.SERVER_URI}${SERVER_CONFIG.API_PATH}${action}`
  // console.log("requestCodexLBServerPost : brandBranch " + action + " " +  brandBranch)
  return (dispatch) => {
    console.log("dispatch " + dispatch);
    axios
      .post(`${CODEXLB_SERVER_URI}core-api/${action}`, newParams, {
        headers: headers,
      })
      .then(
        (response) => {
          // console.log("response " + JSON.stringify(response))
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_CODEXLBSERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });
            if (callback) {
              callback(response);
            }
          }
        },
        (reason) => {
          console.log(reason);
        },
      );
  };
};

// export const requestCodexLBServerGet = (
//   action,
//   params = {},
//   headers = {},
//   callback = null,
//   userToken = "",
// ) => {
//   const systemheaders = {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${userToken}`,
//   };
//   headers = { ...headers, ...systemheaders };

//   const paramsString = JSON.stringify(params);
//   const timestamp = Date.now().toString();
//   const encryptedParams = StringHelper.encryptWithTimeStamp(
//     paramsString,
//     timestamp,
//   );

//   const newParams = {
//     data: encryptedParams,
//     timestamp: timestamp,
//   };

//   const brandBranch = JSON.stringify(
//     StringHelper.extractURLBrandAndBranch(window.location.pathname),
//   );

//   console.log(
//     "requestCodexLBServerGet : brandBranch " + action + " " + brandBranch,
//   );
//   return (dispatch) => {
//     console.log("dispatch " + dispatch);
//     axios
//       .get(`${CODEXLB_SERVER_URI}core-api/${action}`, {
//         params: newParams,
//         headers: headers,
//       })
//       .then(
//         (response) => {
//           console.log("response " + JSON.stringify(response));
//           if (response.status === 200) {
//             dispatch({
//               type: RECEIVE_CODEXLBSERVER_RESPONSE,
//               payload: {
//                 action,
//                 response,
//               },
//             });
//             if (callback) {
//               callback(response);
//             }
//           }
//         }, reason => {
//             console.log(reason)
//         });
//     }
// }

export const requestCoreAPIServerPost = (
  action,
  params = {},
  headers = {},
  callback = null,
  userToken = "",
) => {
  const systemheaders = { "Content-Type": "application/json" };
  headers = { ...headers, ...systemheaders };

  const paramsString = JSON.stringify(params);
  const timestamp = Date.now().toString();
  const encryptedParams = StringHelper.encryptWithTimeStamp(
    paramsString,
    timestamp,
  );

  const newParams = {
    data: encryptedParams,
    timestamp: timestamp,
  };

  const brandBranch = JSON.stringify(
    StringHelper.extractURLBrandAndBranch(window.location.pathname),
  );

  return (dispatch) => {
    console.log("dispatch " + dispatch);
    axios
      .post(`${CODEXLB_SERVER_URI}core-api/${action}`, newParams, {
        // axios.post(`${SERVER_CONFIG.SERVER_URI}core-api/${action}`, newParams, {
        headers: headers,
      })
      .then(
        (response) => {
          // console.log("response " + JSON.stringify(response))
          if (response.status === 200) {
            dispatch({
              type: RECEIVE_CODEXLBSERVER_RESPONSE,
              payload: {
                action,
                response,
              },
            });
            if (callback) {
              callback(response);
            }
          }
        },
        (reason) => {
          console.log(reason);
        },
      );
  };
};

// export const requestCodexLBServerGet = (action, params = {}, headers = {}
//     , callback = null, userToken = "") => {
//     const systemheaders = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${userToken}` }
//     headers = { ...headers, ...systemheaders };

//     const paramsString = JSON.stringify(params);
//     const timestamp = Date.now().toString();
//     const encryptedParams = StringHelper.encryptWithTimeStamp(paramsString, timestamp);

//     const newParams = {
//         data: encryptedParams,
//         timestamp: timestamp
//     }

//     const brandBranch = JSON.stringify(StringHelper.extractURLBrandAndBranch(window.location.pathname));

//     console.log("requestCodexLBServerGet : brandBranch " + action + " " + brandBranch)
//     return (dispatch) => {
//         console.log("dispatch " + dispatch)
//         axios.get(`${CODEXLB_SERVER_URI}core-api/${action}`, {
//             params: newParams,
//             headers: headers
//         }).then((response) => {
//             console.log("response " + JSON.stringify(response))
//             if (response.status === 200) {
//                 dispatch({
//                     type: RECEIVE_CODEXLBSERVER_RESPONSE,
//                     payload: {
//                         action,
//                         response
//                     }
//                 });
//                 if (callback) {
//                     callback(response);
//                 }
//             }

//         }, reason => {
//             console.log(reason)
//         });
//     }
// }
